var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard__card" },
    [
      _vm.loaders.dashboardData ? _c("CardLoading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dashboard__card-content",
          class: { loadingBlur: _vm.loaders.dashboardData }
        },
        [
          _c("div", { staticClass: "dashboard__card-header" }, [
            _c("div", { staticClass: "dashboard__card-title" }, [
              _vm._v("Fuel Utilization")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "dashboard__card-title-addendum" }, [
              _vm._v(_vm._s(_vm.dateRangeText))
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row dashboard__card-body dashboard__card-body--bordered"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "dashboard__grid dash-fuel-utilization__content-container"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-6 dashboard__card-body-col dashboard__card-body-col--fuel-utilization"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "row hearing-aid-sales__filters dash-fuel-utilization__date-range"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "filter-sales-dates__from-date filter-selection"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "filter-selection__title" },
                                [_vm._v("From:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "filter-selection__body" },
                                [
                                  _c("Datepicker", {
                                    staticClass:
                                      "filter-selection__select filter-selection__select--date filter-selection__select--left",
                                    attrs: {
                                      name: "select-month-from",
                                      placeholder: "From",
                                      format: "MMM yyyy",
                                      "minimum-view": "month",
                                      disabled: _vm.fuelUtilDisabledRangeFrom
                                    },
                                    model: {
                                      value: _vm.fuelUtilDateFrom,
                                      callback: function($$v) {
                                        _vm.fuelUtilDateFrom = $$v
                                      },
                                      expression: "fuelUtilDateFrom"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "filter-sales-dates__to-date filter-selection"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "filter-selection__title" },
                                [_vm._v("To:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "filter-selection__body" },
                                [
                                  _c("Datepicker", {
                                    staticClass:
                                      "filter-selection__select filter-selection__select--date filter-selection__select--left",
                                    attrs: {
                                      name: "select-month-to",
                                      placeholder: "To",
                                      format: "MMM yyyy",
                                      "minimum-view": "month",
                                      disabled: _vm.fuelUtilDisabledRangeTo
                                    },
                                    model: {
                                      value: _vm.fuelUtilDateTo,
                                      callback: function($$v) {
                                        _vm.fuelUtilDateTo = $$v
                                      },
                                      expression: "fuelUtilDateTo"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "filter-sales-dates__submit filter-selection"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "filter-selection__title" },
                                [_vm._v(" ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "filter-selection__body" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dashboard__card-link h-center-align h-clear",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.getFuelUtilization($event)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "dashboard__card-link-text",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                            }
                                          }
                                        },
                                        [_vm._v("Load")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _vm.dashboardData.hoursWorked > -1
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dash-fuel-utilization__time-stat"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-utilization__hours"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.dashboardData.hoursWorked)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-utilization__hours-worked"
                                    },
                                    [_vm._v("Hours Worked in this Period")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dash-fuel-utilization__counters"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-utilization__stats-container"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__count"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.dashboardData
                                                  .totalWorkOrders
                                              )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__category"
                                        },
                                        [_vm._v("Total Work Orders")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-utilization__stats-container"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__count"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.dashboardData.activeWOs
                                              )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._m(1)
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-utilization__stats-container"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__count"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.dashboardData.completedWOs
                                              )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._m(2)
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dash-fuel-utilization__order-stats"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-utilization__container dash-fuel-utilization__container--department"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__container-header"
                                        },
                                        [_vm._v("Department")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.dashboardData.countByType,
                                        function(dept) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dash-fuel-utilization__dept-name"
                                            },
                                            [_vm._v(_vm._s(dept.Department))]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-utilization__container dash-fuel-utilization__container--active"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__container-header"
                                        },
                                        [_vm._v("Active")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.dashboardData.countByType,
                                        function(count) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dash-fuel-utilization__active-stat"
                                            },
                                            [_vm._v(_vm._s(count.Open))]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-utilization__container dash-fuel-utilization__container--completed"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__container-header"
                                        },
                                        [_vm._v("Completed")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.dashboardData.countByType,
                                        function(count) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dash-fuel-utilization__completed-stat"
                                            },
                                            [_vm._v(_vm._s(count.Completed))]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-utilization__container dash-fuel-utilization__container--hours"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__container-header"
                                        },
                                        [_vm._v("Hours")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.dashboardData.countByType,
                                        function(count) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dash-fuel-utilization__completed-stat"
                                            },
                                            [_vm._v(_vm._s(count.Hours))]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ]
                              )
                            ])
                          : _c("div", { staticClass: "alert alert-warning" }, [
                              _c("div", { staticClass: "dashboard__no-data" }, [
                                _vm._v("No recent fuel utilization activity")
                              ])
                            ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-6 dashboard__card-body-col dashboard__card-body-col--shaded dashboard__card-body-col--fuel-utilization"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _vm.workOrders.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "dash-fuel-utilization__work-orders"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dash-fuel-utilization__recent-work-orders-header"
                                  },
                                  [_vm._v("Recent In Progress")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.workOrders, function(
                                  workOrder,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: workOrder.id,
                                      staticClass:
                                        "dash-fuel-utilization__work-order"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__work-order-name"
                                        },
                                        [_vm._v(_vm._s(workOrder.title))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__work-order-status",
                                          class: _vm.workOrderStatusClass(
                                            workOrder.portalStatus
                                          )
                                        },
                                        [_vm._v(_vm._s(workOrder.portalStatus))]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          : _c("div", { staticClass: "alert alert-warning" }, [
                              _c("div", { staticClass: "dashboard__no-data" }, [
                                _vm._v("No recent work order activity")
                              ])
                            ])
                      ])
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard__card-footer" }, [
            _c(
              "div",
              { staticClass: "dashboard__card-link" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "dashboard__card-link-text",
                    attrs: { to: "/fuel-utilization" }
                  },
                  [_vm._v("View All")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "dashboard__card-title-icon dashboard__card-title-icon--fuel-utilization"
      },
      [_c("i", { staticClass: "fa fa-tasks" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dash-fuel-utilization__category" }, [
      _vm._v("Active"),
      _c("br"),
      _vm._v("work orders")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dash-fuel-utilization__category" }, [
      _vm._v("Completed"),
      _c("br"),
      _vm._v("work orders")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }